"use strict";
var ACC;
ACC.cart = {

	_autoload: [
		"bindHelp",
        "displayCleanCartUrl",
		"bindTableAccessibilityRoles",
		"cartRestoration",
        "selectricInit",
        "showFooterCardIcons",
        "trackGtm",
        "fixedCartCheckoutFooterVisibility"
	],

	bindHelp: function(){
		$(document).on("click",".js-cart-help",function(e){
			e.preventDefault();
			var title = $(this).data("help");
			ACC.colorbox.open(title,{
				html:$(".js-help-popup-content").html(),
				width:"300px"
			});
		});
	},

    displayCleanCartUrl: function() {
        if (window.location.href.indexOf("paymentStatus") > -1) {
            var cleanUrl = window.location.href.split("?")[0];
            window.history.replaceState({}, document.title, cleanUrl);
        }
    },

    bindTableAccessibilityRoles: function() {
        enquire.register('screen and (min-width:641px)', {
            match: function () {
                $('[data-aria-role-desktop]').each(function() {
                    var role = $(this).data('aria-role-desktop');
                    $(this).attr('role', role);
                })
            },
            unmatch: function () {
                $('[data-aria-role-desktop]').each(function() {
                    $(this).removeAttr('role');
                })
            }
        });
    },

	cartRestoration: function(){
		$('.cartRestoration').click(function(){
			var sCartUrl = $(this).data("cartUrl");
			window.location = sCartUrl;
		});
	},

    selectricInit: function() {
        if ($('.basket-items').length > 0) {
            $('.basket-items select').accessibleSelectric();
        }
    },

    showFooterCardIcons: function() {
        if (ACC.gtm.pageType === 'CartPage') {
            $('.footer-card-icons').removeClass('hidden');
        }
    },

    trackGtm: function() {
        $(window).on('load', function () {
            if (ACC.gtm.pageType === 'CartPage') {
                ACC.gtm.trackBasketPage();
            }
        });
    },

    fixedCartCheckoutFooterVisibility: function() {
        const footer = document.getElementById('footer');
        const cartCheckout = document.getElementsByClassName('cart-checkout')[0];
        const cartCheckoutFixed = cartCheckout && window.getComputedStyle(cartCheckout).position == 'fixed';
        if (footer && cartCheckoutFixed) {
            footer.style.marginBottom = '230px';
        }
    }
};

window.addEventListener('resize', function() {
    ACC.cart.fixedCartCheckoutFooterVisibility();
});
